module.exports = __webpack_public_path__ + "static/income.b4f07fd5.png";